'use client';

import { VideoImageData } from '@workspace/interfaces';

import { AppVideoImage } from '@/app/common';

interface VideoImageRendererProps {
  block: VideoImageData;
}
export const VideoImageRenderer = ({ block }: VideoImageRendererProps) => {
  const {
    imageHeading,
    textOverlay,
    variant,
    buttons,
    description,
    heading,
    image,
    isVideo,
    thumbnail,
    video,
    sectionAnchorId,
  } = block;
  return (
    <div className="bg-black" id={sectionAnchorId?.current || undefined}>
      <AppVideoImage
        variant={variant}
        imageHeading={imageHeading}
        textOverlay={textOverlay}
        buttons={buttons}
        description={description}
        heading={heading}
        image={image}
        isVideo={isVideo}
        thumbnail={thumbnail}
        video={video}
        // Ensure video stretches to full width on >=1440px screens by increasing height
        wrapperClassName="xl:min-h-[56.25vw]"
      />
    </div>
  );
};
